import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

const RouteLoader = () => (
  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh'}}>
    <CircularProgress size={28} />
  </div>
)

export default RouteLoader
